import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicantTrackerResources } from '@applicant-tracker/applicant-tracker.resource';

@Injectable()
export class SubscriptionService {
    constructor(private http: HttpClient) {}

    async subscribe(topicId: number) {
        const url = ApplicantTrackerResources.SubscribeToTopic.replace(':topic', topicId.toString());
        return await this.http.post(url, null).toPromise();
    }

    async unsubscribe(topicId: number) {
        const url = ApplicantTrackerResources.UnsubscribeFromTopic.replace(':topic', topicId.toString());
        return await this.http.post(url, null).toPromise();
    }
}
